import { Card, CardBody, Col, Row } from "reactstrap";
import { ListingTypography } from "../../../../Constant";
import { UnorderLists } from "./UnorderLists";
import { OrderList } from "./OrderList";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { LISTING_DATA } from "../../../../Data/UiKit/Typography";
import { OrderListSecond } from "./OrderListSecond";

const ListingCard = () => {
  return (
    <Col sm="12" className="listing">
      <Card>
        <CommonCardHeader title={ListingTypography} span={LISTING_DATA} />
        <CardBody>
          <Row className="g-3">
            <UnorderLists />
            <OrderList />
            <OrderListSecond />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ListingCard;
